import { createThunks } from 'tsx/libs/reduxUtils';
import { get } from 'tsx/libs/genericAction';
import { apiAppointmentStatuses } from 'tsx/constants/api';

export const typePrefix = 'appointments-statuses';

const config = [{ actionType: 'getAll', apiPath: apiAppointmentStatuses, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
